export interface SavedSearch {
  id: number
  name: string
  searchQuery: string
  alertsEnabled: boolean
  alertsFrequency: SavedSearchAlertsFrequency
  newItemsCount: number
}

export enum SavedSearchAlertsFrequency {
  NO_NOTIFICATION = 'NO_NOTIFICATION',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}
